<template>
    <div>
        <b-col sm="6" class="mx-0 px-0 my-0 py-0 form-inline">
            <b-input-group class="mb-2 ">
                <b-input-group-prepend is-text>
                    <b-form-checkbox
                        class="mr-n2"
                        v-model="isnullable"
                        value="notnull"
                        unchecked-value="null"
                        @input="set_inputCB"
                        :disabled="!editAllowed"
                    >
                        <span class="sr-only">Niet</span>
                    </b-form-checkbox>
                    <b-form-checkbox
                        class="mr-n2"
                        v-model="status"
                        value="time"
                        unchecked-value="date"
                        @input="set_inputCB"
                        :disabled="!editAllowed"
                    >
                        <span class="sr-only">{{
                            $t('com_met', { ns: 'common' }) +
                            ' ' +
                            $t('com_tijd', { ns: 'common' })
                        }}</span>
                    </b-form-checkbox>
                </b-input-group-prepend>

                <b-input-group v-if="!useTimeInput">
                    <b-form-datepicker
                        v-if="nullable"
                        :date-format-options="{
                            year: 'numeric',
                            month: 'short',
                            day: '2-digit'
                        }"
                        v-model="datum"
                        @input="set_input"
                        :disabled="!editAllowed"
                    ></b-form-datepicker>
                </b-input-group>
                <b-input-group v-if="useTimeInput">
                    <b-form-input
                        v-if="nullable"
                        v-model="datum"
                        :type="'date'"
                        @blur="set_input"
                        :disabled="!editAllowed"
                    ></b-form-input>
                </b-input-group>
            </b-input-group>
        </b-col>
        <b-col sm="6" v-if="metTijd" class="mx-0 px-0 my-0 py-0 form-inline">
            <b-input-group
                class="mb-2"
                :prepend="$t('com_tijd', { ns: 'common' })"
            >
                <b-input-group v-if="!useTimeInput">
                    <b-form-timepicker
                        v-model="tijd"
                        @input="set_input"
                        :disabled="!editAllowed"
                    ></b-form-timepicker>
                </b-input-group>
                <b-input-group v-if="useTimeInput">
                    <b-form-input
                        v-model="tijd"
                        :type="'time'"
                        @blur="set_input"
                        :disabled="!editAllowed"
                    ></b-form-input>
                </b-input-group>
            </b-input-group>
        </b-col>
    </div>
</template>

<script>
import DateHelper from '../../models/DateHelper';
import { Feature } from '../../models/Features';
export default {
    name: 'AnalyticsDateTime',
    data: function () {
        return {
            status: 'time',
            isnullable: 'notnull',
            datum: null,
            tijd: null,
            isCloseable: false
        };
    },
    model: {
        prop: 'selected',
        event: 'input'
    },
    props: {
        selected: {},
        editAllowed: {
            type: Boolean,
            default: true
        },
        timeInput: {
            type: Boolean,
            default: false
        },
        startNull: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        metTijd() {
            return this.status == 'time' && this.nullable;
        },
        useTimeInput() {
            if (this.timeInput) {
                return false;
            }
            return !this.checkFeature('conf_UseDateTimePicker');
        },
        nullable() {
            return this.isnullable == 'notnull';
        }
    },
    methods: {
        checkFeature(feature) {
            const key = Feature.enum(feature);
            return this.$root.handleFeature(key);
        },
        set_input() {
            const temptijd = this.maakTijd();
            this.$emit('change', temptijd);
        },
        set_inputCB() {
            const resDatum =
                this.isnullable == 'notnull' ? this.datum ?? new Date() : null;
            const resTijd =
                this.status == 'time'
                    ? this.tijd ?? DateHelper.convertedToTime(new Date())
                    //? this.tijd ?? DateHelper.DateFromInput(new Date())
                    : null;
            this.datum = DateHelper.DateForInput(resDatum, true, false);
            this.tijd = resTijd;
            this.set_input();
        },
        maakTijd() {
            let res = this.datum;
            // if (this.metTijd) {
            //     res = DateHelper.convertedFromTimepicker(this.datum, this.tijd);
            // }
            res = DateHelper.DateFromInput(
                    this.datum,
                    this.metTijd ? this.tijd : null
                );
            res = this.isnullable == 'notnull' ? res : null;
            return res;
        }
    },
    mounted() {},
    created() {
        // this.datum = DateHelper.convertedToDateTimeJS(this.selected);
        // this.tijd = DateHelper.convertedToTime(this.selected);
        this.datum= DateHelper.DateForInput(this.selected, true, false);
        this.tijd = DateHelper.DateForInput(this.selected, false, true);
        this.isnullable =
            this.selected == undefined
                ? 'null'
                : this.startNull
                ? 'null'
                : 'notnull';
        this.status = this.isnullable == 'null' ? 'date' : 'time';
        this.set_input();
    }
};
</script>

<style scoped></style>

